import { useMemo } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { createCustomer } from "../../../service/customer";
import { showToast, countries } from "../../../utils/helper";
import { startLoading, stopLoading } from "../../../redux/loader";

export const useAddCustomer = (
  setIsCustomerModalOpen,
  setCustomerSelectedHandler,
  userID
) => {
  const dispatch = useDispatch();

  const loggedInUser = useSelector((state) => state.loggedInUser);

  const countryCodeList = useMemo(() => {
    return countries?.map((country) => {
      return {
        label: `${country.phone} (${country.label})`,
        value: country.phone.split('+')[1]
      }
    })
  }, [countries]);

  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      customer_name: "",
      countryCode: "",
      phone: "",
      dob: new Date(),
      gender: "male",
    },
    mode: "onBlur",
  });

  const onSubmit = async (data) => {
    try {
      dispatch(startLoading());
      const payload = {
        userID: userID ? userID : loggedInUser.id,
        phoneNumber: data.phone,
        gender: data.gender,
        name: data.customer_name,
        dob: data.dob,
        countryCode: data.countryCode,
        createdBy: userID ? userID : loggedInUser.id,
      };

      const response = await createCustomer(payload);
      if (response?.statusCode === 200) {
        showToast(response?.message, true);
        setIsCustomerModalOpen(false);
        setCustomerSelectedHandler(
          response.data.id,
          payload.phoneNumber,
          payload.name,
          response.data.customerNo
        );
        reset();
      } else {
        showToast(response?.message || response?.messageCode, false);
      }
    } catch (error) {
      showToast(error?.message, false);
    } finally {
      dispatch(stopLoading());
    }
  };

  return {
    control,
    countryCodeList,
    handleSubmit,
    onSubmit,
    reset,
  };
};
